import React from 'react'
import LeftSideMenu from './LeftSideMenu'
import ActiveProxiesTable from './ActiveProxiesTable'
import useMobile from './hooks/useMobile'

const ActiveProxies = (props) => {
    const { isMobile } = useMobile()
    const activeProxiesList = props.active || []

    return (
        <div style={{
            display: 'flex',
            height: '100vh',
        }}>
            {!isMobile && <LeftSideMenu user={props.user} active={props.active} apiClient={props.apiClient}/>}
            <ActiveProxiesTable 
                list={activeProxiesList} 
                user={props.user} 
                active={props.active} 
                apiClient={props.apiClient} 
                setReloadActive={props.setReloadActive}
                refreshUserData={props.refreshUserData}
            />
        </div>
    )
}

export default ActiveProxies